// The one list of project recurrences the UI offers. The New Project modal,
// the For Many Clients dialog and the account-page Edit Project dialog all
// render this, so they can't drift apart again (ENG-129: the edit dialog never
// got Semi-Monthly and showed a blank Recurrence field for those projects).
//
// Every value here must also be in the projects_recurring_pattern_check
// constraint and in advanceByPattern (server/routes.ts); the ratchet in
// server/routes.recurring-pattern-constraint.test.ts enforces both.
// "none" is the One-time sentinel: the dropdowns map it to "" / null.
export const RECURRENCE_OPTIONS = [
  { value: "none", label: "One-time" },
  { value: "daily", label: "Daily" },
  { value: "weekly", label: "Weekly" },
  { value: "bi-weekly", label: "Bi-Weekly (every 2 weeks)" },
  { value: "semi-monthly", label: "Semi-Monthly (1st & 15th)" },
  { value: "monthly", label: "Monthly" },
  { value: "quarterly", label: "Quarterly (every 3 months)" },
  { value: "semi-annual", label: "Semi-Annual (every 6 months)" },
  { value: "yearly", label: "Yearly" },
] as const;
